import { useEffect } from "react";
import { trackJobTime } from "../../api/batches";

export default function Tracker({ jobId }: { jobId: string }) {
  // Time tracking with 10-second heartbeat
  useEffect(() => {
    // Only track time if we have a valid jobId and the component is mounted
    if (!jobId) return;

    let accumulatedTime = 0;
    let startTime = Date.now();

    // Send time tracking data to server
    const trackTime = async () => {
      if (!jobId) return;

      try {
        // Calculate time spent since last heartbeat (in seconds)
        const currentTime = Date.now();
        const timeSpent = Math.round((currentTime - startTime) / 1000);
        accumulatedTime += timeSpent;

        // Reset the start time for next interval
        startTime = currentTime;

        // Only send if we have accumulated time to report
        if (accumulatedTime > 0) {
          trackJobTime({
            jobId,
            timeSpentSeconds: accumulatedTime,
          });

          // Reset accumulated time after successful tracking
          accumulatedTime = 0;
        }
      } catch (error) {
        // Silently fail but keep the accumulated time for next attempt
        // console.error("Error tracking time:", error);
      }
    };

    // Set up heartbeat interval
    const heartbeatInterval = setInterval(trackTime, 5000); // 5 seconds

    // Handle visibility change (tab switch/minimize)
    // const handleVisibilityChange = () => {
    //   if (document.visibilityState === "visible") {
    //     // User returned to the tab - restart tracking
    //     isActive = true;
    //     startTime = Date.now();
    //   } else {
    //     // User left the tab - pause tracking and send accumulated time
    //     isActive = false;
    //     trackTime();
    //   }
    // };

    // Set up visibility change listener
    // document.addEventListener("visibilitychange", handleVisibilityChange);

    // Cleanup function
    return () => {
      // Send final tracking data when component unmounts
      trackTime();
      clearInterval(heartbeatInterval);
      // document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [jobId]); // Only re-run if jobId changes

  return null;
}
